// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TaskCreateCommandFromJSON(json) {
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'taskID': !exists(json, 'taskID') ? undefined : json['taskID'],
        'projectID': !exists(json, 'projectID') ? undefined : json['projectID'],
        'taskDescription': !exists(json, 'taskDescription') ? undefined : json['taskDescription'],
        'taskType': !exists(json, 'taskType') ? undefined : json['taskType'],
        'taskPriority': !exists(json, 'taskPriority') ? undefined : json['taskPriority'],
        'pmNotes': !exists(json, 'pmNotes') ? undefined : json['pmNotes'],
        'taskAssignTo': !exists(json, 'taskAssignTo') ? undefined : json['taskAssignTo'],
        'taskAssignToEmail': !exists(json, 'taskAssignToEmail') ? undefined : json['taskAssignToEmail'],
        'taskManagedBy': !exists(json, 'taskManagedBy') ? undefined : json['taskManagedBy'],
        'taskManagedByEmail': !exists(json, 'taskManagedByEmail') ? undefined : json['taskManagedByEmail'],
        'taskApprovAmount': !exists(json, 'taskApprovAmount') ? undefined : json['taskApprovAmount'],
        'approStatus': !exists(json, 'approStatus') ? undefined : json['approStatus'],
        'taskRouteID': !exists(json, 'taskRouteID') ? undefined : json['taskRouteID'],
        'taskRouteStepNum': !exists(json, 'taskRouteStepNum') ? undefined : json['taskRouteStepNum'],
        'taskRouteStepTargetDays': !exists(json, 'taskRouteStepTargetDays') ? undefined : json['taskRouteStepTargetDays'],
        'taskRouteStepDescription': !exists(json, 'taskRouteStepDescription') ? undefined : json['taskRouteStepDescription'],
        'nextStepTaskID': !exists(json, 'nextStepTaskID') ? undefined : json['nextStepTaskID'],
        'taskApprovalRoute': !exists(json, 'taskApprovalRoute') ? undefined : json['taskApprovalRoute'],
        'invoiceNum': !exists(json, 'invoiceNum') ? undefined : json['invoiceNum'],
        'invoiceAmount': !exists(json, 'invoiceAmount') ? undefined : json['invoiceAmount'],
        'commitNum': !exists(json, 'commitNum') ? undefined : json['commitNum'],
        'propertyID': !exists(json, 'propertyID') ? undefined : json['propertyID'],
        'pjtNumber': !exists(json, 'pjtNumber') ? undefined : json['pjtNumber'],
        'externalTable': !exists(json, 'externalTable') ? undefined : json['externalTable'],
        'externalTableID': !exists(json, 'externalTableID') ? undefined : json['externalTableID'],
        'notifiedDate': !exists(json, 'notifiedDate') ? undefined : new Date(json['notifiedDate']),
        'receivedDate': !exists(json, 'receivedDate') ? undefined : new Date(json['receivedDate']),
        'targetDate': !exists(json, 'targetDate') ? undefined : new Date(json['targetDate']),
        'completeDate': !exists(json, 'completeDate') ? undefined : new Date(json['completeDate']),
        'todayDate': !exists(json, 'todayDate') ? undefined : new Date(json['todayDate']),
        'changeRequestDate': !exists(json, 'changeRequestDate') ? undefined : new Date(json['changeRequestDate']),
        'changeOrderToCOSTSDate': !exists(json, 'changeOrderToCOSTSDate') ? undefined : new Date(json['changeOrderToCOSTSDate']),
        'invoiceToCOSTSDate': !exists(json, 'invoiceToCOSTSDate') ? undefined : new Date(json['invoiceToCOSTSDate']),
        'bulletinDate': !exists(json, 'bulletinDate') ? undefined : new Date(json['bulletinDate']),
        'assigneeContactID': !exists(json, 'assigneeContactID') ? undefined : json['assigneeContactID'],
        'managedByContactID': !exists(json, 'managedByContactID') ? undefined : json['managedByContactID'],
        'taskViewersContactIDs': !exists(json, 'taskViewersContactIDs') ? undefined : json['taskViewersContactIDs'],
        'taskProjectTeamContactIDs': !exists(json, 'taskProjectTeamContactIDs') ? undefined : json['taskProjectTeamContactIDs'],
        'lastWebEmailTemplate': !exists(json, 'lastWebEmailTemplate') ? undefined : json['lastWebEmailTemplate'],
    };
}
export function TaskCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'taskID': value.taskID,
        'projectID': value.projectID,
        'taskDescription': value.taskDescription,
        'taskType': value.taskType,
        'taskPriority': value.taskPriority,
        'pmNotes': value.pmNotes,
        'taskAssignTo': value.taskAssignTo,
        'taskAssignToEmail': value.taskAssignToEmail,
        'taskManagedBy': value.taskManagedBy,
        'taskManagedByEmail': value.taskManagedByEmail,
        'taskApprovAmount': value.taskApprovAmount,
        'approStatus': value.approStatus,
        'taskRouteID': value.taskRouteID,
        'taskRouteStepNum': value.taskRouteStepNum,
        'taskRouteStepTargetDays': value.taskRouteStepTargetDays,
        'taskRouteStepDescription': value.taskRouteStepDescription,
        'nextStepTaskID': value.nextStepTaskID,
        'taskApprovalRoute': value.taskApprovalRoute,
        'invoiceNum': value.invoiceNum,
        'invoiceAmount': value.invoiceAmount,
        'commitNum': value.commitNum,
        'propertyID': value.propertyID,
        'pjtNumber': value.pjtNumber,
        'externalTable': value.externalTable,
        'externalTableID': value.externalTableID,
        'notifiedDate': value.notifiedDate === undefined ? undefined : value.notifiedDate.toISOString(),
        'receivedDate': value.receivedDate === undefined ? undefined : value.receivedDate.toISOString(),
        'targetDate': value.targetDate === undefined ? undefined : value.targetDate.toISOString(),
        'completeDate': value.completeDate === undefined ? undefined : value.completeDate.toISOString(),
        'todayDate': value.todayDate === undefined ? undefined : value.todayDate.toISOString(),
        'changeRequestDate': value.changeRequestDate === undefined ? undefined : value.changeRequestDate.toISOString(),
        'changeOrderToCOSTSDate': value.changeOrderToCOSTSDate === undefined ? undefined : value.changeOrderToCOSTSDate.toISOString(),
        'invoiceToCOSTSDate': value.invoiceToCOSTSDate === undefined ? undefined : value.invoiceToCOSTSDate.toISOString(),
        'bulletinDate': value.bulletinDate === undefined ? undefined : value.bulletinDate.toISOString(),
        'assigneeContactID': value.assigneeContactID,
        'managedByContactID': value.managedByContactID,
        'taskViewersContactIDs': value.taskViewersContactIDs,
        'taskProjectTeamContactIDs': value.taskProjectTeamContactIDs,
        'lastWebEmailTemplate': value.lastWebEmailTemplate,
    };
}
